// extracted by mini-css-extract-plugin
export default {"groupe_cartes":"EditerCeaf_groupe_cartes__HV6CI"};